import { Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useGetAnalysisHistoryQuery } from '@/app/PageSpeed/api/analysisApi';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import ToolsBreadcrumb from '@/app/common/components/ToolsBreadcrumb';
import DataLoadError from '@/components/errors/DataLoadError';
import {
  isNetworkApiError,
  shouldShowDataLoadError
} from '@/app/common/utils/apiErrorUtils';
import { pageSpeedReportColumnConfig } from '@/app/PageSpeed/config/pageSpeedReportColumnConfig';

const PageSpeedReport = () => {
  const { domain_slug, domain } = useParams<{
    domain_slug?: string;
    domain?: string;
  }>();
  const {
    data: historyData,
    isFetching,
    isError,
    error,
    refetch
  } = useGetAnalysisHistoryQuery();

  const rows = historyData?.data || [];

  if (shouldShowDataLoadError(isError, error)) {
    return (
      <DataLoadError
        onRetry={() => refetch()}
        isRetrying={isFetching}
        isNetworkError={isNetworkApiError(error)}
      />
    );
  }

  return (
    <>
      <ToolsBreadcrumb
        parentName="گزارش‌گیری"
        parentUrl={`/reporting/page_speed/${domain_slug}/${domain}`}
        childs={[]}
      />
      <Card className="mt-3">
        <Card.Body className="p-0">
          <AgGridWrapper
            height="620px"
            columns={pageSpeedReportColumnConfig(domain_slug, domain)}
            data={rows}
            settings={{
              pagination: true,
              fullscreen: false,
              changeHeight: false,
              saveGrid: false,
              resetGrid: false
            }}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default PageSpeedReport;
